import React, { memo } from 'react';

import RichText from 'components/RichText/RichText';
import useOverElement from 'hooks/useOverElement';

import * as S from '../AboutPage.styles';

export interface DoubleColumnTextSectionProps {
  title: string;
  leftSideTextContent: string;
  rightSideTextContent: string;
}

const DoubleColumnTextSection: React.FunctionComponent<
  DoubleColumnTextSectionProps
> = ({ title, leftSideTextContent, rightSideTextContent, ...rest }) => {
  const [ref] = useOverElement();

  return (
    <S.DoubleColumnTextSectionGrid ref={ref} {...rest}>
      <S.DoubleColumnTextSectionWrapper>
        {title && <RichText richText={title} />}

        <S.DoubleColumnTextSectionColumns>
          {leftSideTextContent && <RichText richText={leftSideTextContent} />}
          {rightSideTextContent && <RichText richText={rightSideTextContent} />}
        </S.DoubleColumnTextSectionColumns>
      </S.DoubleColumnTextSectionWrapper>
    </S.DoubleColumnTextSectionGrid>
  );
};

export default memo(DoubleColumnTextSection);
